import { useEffect, useState } from "react";
import TaleOfTheTapeInfoContent from "./TaleOfTheTapeInfoContent";
import CandidateInfoSideNavigation from "../../candidate/parts/CandidateInfoSideNavigation";
import styles from "../../../styles/races/national/TaleOfTheTape.module.scss";

const TaleOfTheTapeInfoSection = ({
  type,
  headline,
  items,
  selectedCandidates,
  scrollHandler
}) => {
  const [selectedKey, setSelectedKey] = useState("0_0");
  const [sideNavItems, setSideNavItems] = useState([]);
  const [contentItems, setContentItems] = useState(undefined);
  const [isDataAvailable, setIsDataAvailable] = useState(false);

  const selectItem = (key) => {
    setSelectedKey(key);
  }

  useEffect(() => {
    const sideNav = [];
    const filteredSideNav = [];

    switch(type) {
      case "highlights-controversies":
      case "promises":
        items.forEach(item => {
          if (item?.length) filteredSideNav = [...item.map(i => i.label)];
        });
        filteredSideNav = [...new Set(filteredSideNav)];
        sideNav = filteredSideNav.map((label, index) => {
          return {
            key: `0_${index}`,
            label
          }
        });

        setSideNavItems(sideNav);
        break;
      case "stances":
        items.forEach(item => {
          item?.forEach(i => {
            const parentIndex = filteredSideNav.findIndex(category => category.parent === i.label);
            if (parentIndex < 0) {
              filteredSideNav.push({
                parent: i.label,
                child: i.content.map(details => details.header.title)
              });
            } else {
              const newChild = [...filteredSideNav[parentIndex].child];
              i.content.map(details => details.header.title).forEach(ic => {
                newChild.push(ic)
              });

              filteredSideNav[parentIndex].child = [...new Set(newChild)];
            }
          });
        });
        
        filteredSideNav.forEach((filteredSideNavItem, index1) => {
          sideNav.push({
            key: `${index1}`,
            label: filteredSideNavItem.parent,
            isCategory: true
          });
          filteredSideNavItem.child.forEach((child, index2) => {
            sideNav.push({
              key: `${index1}_${index2}`,
              label: child
            });
          });
        });
        setSideNavItems(sideNav);
        break;
      default:
        setSideNavItems(sideNav);
        break;
    }
  }, [items, type]);

  useEffect(() => {
    const selectedKeyLabel = sideNavItems.find(sideNavItem => sideNavItem.key === selectedKey)?.label;
    const contentItemsObject = undefined;
    if (selectedKeyLabel) {
      contentItemsObject = {
        label: selectedKeyLabel,
        content: items.map(item => {
          if (item) {
            if (type !== "stances") {
              return item.find(i => i.label === selectedKeyLabel)?.content;
            } else {
              const children = [];
              item.forEach(parent => {
                parent.content.forEach(content => {
                  children.push(content);
                });
              });
              
              return [children.find(c => c.header.title === selectedKeyLabel)];
            }
          } else {
            return [];
          }
        })
      };
    } else if (type === "bio") {
      contentItemsObject = {
        content: items.map(item => {
          return item ? [{ content: item[0].content[0] }] : []
        })
      };
    }
  
    setContentItems(contentItemsObject);
  }, [sideNavItems, selectedKey, items, type]);

  useEffect(() => {
    if (contentItems?.content.findIndex(contentItem => contentItem?.length > 0) >= 0) {
      setIsDataAvailable(true);
    } else {
      setIsDataAvailable(false);
    }
  }, [contentItems]);

  return (
    isDataAvailable &&
    <div className={[styles.section]} style={type === "bio" ? {marginTop : "0px"}: {}}>
      <div className={styles.sideNav}>
        <h3 className={styles.sectionTitle}>{headline}</h3>
        <CandidateInfoSideNavigation
          items={sideNavItems}
          selectedKey={selectedKey}
          onItemSelect={selectItem}
        />
      </div>
        <TaleOfTheTapeInfoContent
          type={type}
          items={contentItems}
          selectedCandidates={selectedCandidates}
          scrollHandler={scrollHandler}
        />
    </div>
  )
};

export default TaleOfTheTapeInfoSection;
